// extracted by mini-css-extract-plugin
module.exports = {"publishedAt":"NewsDetail_publishedAt__1FDa-","image":"NewsDetail_image__300iZ","article":"NewsDetail_article__-MgIT"};